<div class="talent-page-wrapper">
    <!-- Header -->
    <header class="talent-header">
        <div class="logo-section">
            <ng-container *ngIf="logoUrl; else defaultLogo">
                <img [src]="logoUrl" alt="Company Logo"
                    style="max-height: 40px; max-width: 150px; object-fit: contain; margin-right: 10px;">
            </ng-container>
            <ng-template #defaultLogo>
                <div class="logo-icon">
                    <i class="bi bi-cpu-fill"></i>
                </div>
            </ng-template>
            <div class="logo-text">
                <h6>{{ organizationName || 'AI Interview Platform' }}</h6>
            </div>
        </div>
        <div class="secure-badge">
            <span class="dot"></span>
            Secure AI session
        </div>
    </header>

    <div class="verification-page-wrapper">
        <!-- Top Back Navigation -->
        <div class="verification-card">
            <!-- Card Header -->
            <div class="card-header">
                <div class="shield-icon-wrapper">
                    <i class="bi bi-shield-check"></i>
                </div>
                <h2 *ngIf="step === 1">Verify Your Identity</h2>
                <h2 *ngIf="step === 2">Enter Verification Code</h2>
                <p *ngIf="step === 1">We need to verify your identity before starting the interview.</p>
                <p *ngIf="step === 2">We sent a 6-digit code to <span
                        style="color: #4F46E5; font-weight: 700;">{{emailForm.value?.email}}</span></p>
            </div>

            <!-- Step 1: Identity Form -->
            <div *ngIf="step === 1" class="step-container">
                <form [formGroup]="emailForm" (ngSubmit)="sendOTP()" autocomplete="off">
                    <!-- Full Name -->
                    <div class="input-wrapper">
                        <label class="form-label">Full Name</label>
                        <input type="text" class="form-control" formControlName="name" placeholder="Aarav Mehta"
                            minlength="3" maxlength="50" (input)="onNameInput($event)"
                            [class.is-invalid]="f['name'].touched && f['name'].invalid">
                        <div *ngIf="f['name'].touched && f['name'].invalid" class="error-msg">
                            <i class="bi bi-exclamation-circle"></i>
                            <span *ngIf="f['name'].errors?.['required']">Full name is required</span>
                            <span *ngIf="f['name'].errors?.['pattern']">Letters and spaces only</span>
                            <span *ngIf="f['name'].errors?.['minlength'] || f['name'].errors?.['maxlength']">Must be
                                2-50 characters</span>
                        </div>
                    </div>

                    <!-- Email Address -->
                    <div class="input-wrapper">
                        <label class="form-label">Email Address</label>
                        <input type="email" class="form-control" formControlName="email" placeholder="aarav@example.com"
                            minlength="5" maxlength="254" (input)="onEmailInput($event)"
                            [class.is-invalid]="f['email'].touched && f['email'].invalid">
                        <div *ngIf="f['email'].touched && f['email'].invalid" class="error-msg">
                            <i class="bi bi-exclamation-circle"></i>
                            <span *ngIf="f['email'].errors?.['required']">Email is required</span>
                            <span *ngIf="f['email'].errors?.['pattern']">Please enter a valid email</span>
                        </div>
                    </div>

                    <!-- Phone Number -->
                    <div class="input-wrapper">
                        <label class="form-label">Phone Number</label>
                        <div class="phone-group">
                            <select class="form-control country-select" formControlName="countryCode">
                                <option value="" disabled>Code</option>
                                <option *ngFor="let country of countryCodes" [value]="country.dialCode">
                                    {{country.flag}} {{country.dialCode}}
                                </option>
                            </select>
                            <input type="tel" class="form-control flex-grow-1" formControlName="phone"
                                placeholder="9876543210" maxlength="10" (input)="onPhoneInput($event)"
                                [class.is-invalid]="f['phone'].touched && f['phone'].invalid">
                        </div>
                        <div *ngIf="(f['phone'].touched && f['phone'].invalid) || (f['countryCode'].touched && f['countryCode'].invalid)"
                            class="error-msg">
                            <i class="bi bi-exclamation-circle"></i>
                            <span *ngIf="f['countryCode'].errors?.['required']">Code required</span>
                            <span
                                *ngIf="f['phone'].errors?.['required'] && !f['countryCode'].errors?.['required']">Phone
                                is required</span>
                            <span *ngIf="f['phone'].errors?.['pattern']">Must be 10 digits</span>
                        </div>
                    </div>

                    <button type="submit" class="submit-btn" [disabled]="emailForm.invalid || isLoading">
                        <span>Send OTP</span>
                        <i class="bi bi-arrow-right"></i>
                    </button>
                </form>
            </div>

            <!-- Step 2: OTP Entry -->
            <div *ngIf="step === 2" class="step-container">


                <div class="otp-boxes-wrapper">
                    <input *ngFor="let box of otpBoxes; let i = index" [id]="'otp-' + i" type="text"
                        class="form-control otp-box" [(ngModel)]="otpString[i]" maxlength="1" inputmode="numeric"
                        (input)="onOtpInput($event, i)" (keydown)="onOtpKeydown($event, i)"
                        (paste)="onOtpPaste($event)">
                </div>

                <a class="resend-link" [class.disabled]="resendTimer > 0 || resendCount >= maxResends"
                    (click)="resendOTP()">
                    <i class="bi bi-arrow-clockwise"></i>
                    {{ resendTimer > 0 ? 'Resend code in ' + formatTimer() : 'Resend OTP' }}
                </a>

                <div class="mt-4">
                    <button type="button" class="submit-btn" [disabled]="otpForm.invalid || isLoading"
                        (click)="verifyOTP()">
                        <span>Verify OTP</span>
                        <i class="bi bi-arrow-right"></i>
                    </button>
                </div>

                <!-- <a (click)="goBackToStep1()" class="resend-link mt-3 opacity-75">
                    ← Edit details
                </a> -->
            </div>

            <div class="footer-text">
                By continuing you agree to our <a href="#">terms</a> and <a href="#">privacy policy</a>.
            </div>
        </div>
    </div>
</div>

<!-- Premium Loader -->
<div *ngIf="isLoading" class="premium-loader-overlay">
    <div class="premium-spinner">
        <div class="spinner-ring"></div>
        <i class="bi bi-cpu-fill spinner-icon"></i>
    </div>
</div>